module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "disableOutsideClick": true,
      "size": "sequence_size",
      "title": "Assessment Criteria"
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [(_vm.criteria) ? _c('div', {
    staticClass: "flex flex-col space-y-3 overflow-y-auto h-full pb-6 px-6"
  }, _vm._l((_vm.criteria), function(cr, index) {
    return _c('div', {
      key: index,
      staticClass: "flex flex-col space-y-2 bg-gray-100 border border-solid border-gray-200 rounded px-4 py-3"
    }, [_c('div', {
      staticClass: "flex flex-col space-y-2 mb-3"
    }, [_c('h6', {
      staticClass: "font-poppins text-gray-800 font-semibold"
    }, [_vm._v(_vm._s(cr.title))]), _vm._v(" "), (Array.isArray(cr.description)) ? _c('span', [_vm._v(_vm._s(cr.description[0]))]) : _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(cr.description)
      }
    })])]), _vm._v(" "), (cr.points_description && cr.points_description.length > 0 && _vm.getCurrentDiscussion.point_cap !== null) ? _c('div', _vm._l((cr.points_description), function(point_desc) {
      return _c('div', [(point_desc.description !== '') ? _c('div', {
        staticClass: "flex flex-col space-y-2 border border-solid border-gray-200 px-2 py-2 rounded bg-white space-x-2 mb-2"
      }, [_c('div', {
        staticClass: "flex items-center space-x-2"
      }, [_c('div', {
        staticClass: "border bg-gray-100 font-poppins border-solid space-x-2 border-gray-200 flex px-2.5 items-center w-full h-7 rounded"
      }, [_c('span', {
        staticClass: "font-poppins text-sm"
      }, [_vm._v("Level")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(point_desc.value))])])]), _vm._v(" "), _c('div', {
        staticClass: "font-poppins text-sm text-gray-700"
      }, [_vm._v("\n              " + _vm._s(point_desc.description) + "\n            ")])]) : _vm._e()])
    }), 0) : _vm._e()])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-d8c6d4e0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/Modals/LDViewCriteria.vue
// module id = 1905
// module chunks = 61